// Mixpanel provider wrapper
export function track(name: string, props: Record<string, unknown> = {}) {
  try {
    const win = window as any
    if (win.mixpanel && typeof win.mixpanel.track === 'function') {
      win.mixpanel.track(name, props)
    }
  } catch (err) {
    // eslint-disable-next-line no-console
    console.error('mixpanel.track error', err)
  }
}
